module.exports = __webpack_public_path__ + "static/media/cursor.e2d459da.png";